// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6IfVW","productName":"Table_productName__1NhlV"};